<template>
  <div class="sci-page-wrapper" style="font-family: 'Inter', sans-serif; background: #f4f6f9; min-height: 100vh;">
    <div class="max-w-5xl mx-auto px-4 pt-24 pb-6">
      
      <!-- HEADER -->
      <div class="sci-page-header pb-6">
        <button 
          @click="$router.push({ path: `/parts-and-services/biddings-manager/edit/${b_id}`, query: { tab: 3 } })"
          class="flex items-center gap-2 text-slate-500 hover:text-orange-600 transition-colors mb-4 group"
        >
          <v-icon small class="group-hover:-translate-x-1 transition-transform" color="inherit">mdi-arrow-left</v-icon>
          <span class="text-[10px] font-black uppercase tracking-widest">Voltar para a licitação</span>
        </button>
        <div class="flex items-center justify-between">
          <div>
            <h1 class="text-3xl font-black text-slate-800 uppercase tracking-tight">
              {{ id ? 'Editar Contrato' : 'Novo Contrato' }}
            </h1>
            <p class="text-sm text-slate-500 font-medium mt-1">Contrato vinculado à licitação de peças e serviços</p>
          </div>
        </div>
      </div>

      <v-form ref="form" v-model="valid" lazy-validation>
        <div class="space-y-6">
            
            <!-- SEÇÃO: DADOS DO CONTRATO -->
            <section class="bg-white rounded-xl border border-slate-200 overflow-hidden shadow-sm">
              <div class="px-6 py-3 flex items-center gap-3" style="background-color: #333333;">
                <v-icon color="orange" small>mdi-file-certificate-outline</v-icon>
                <h2 class="text-white font-bold uppercase tracking-widest text-[11px]">DADOS DO CONTRATO</h2>
              </div>
              
              <div class="p-6">
                <div class="grid grid-cols-1 md:grid-cols-12 gap-6">
                  <!-- Licitação -->
                  <div class="md:col-span-3">
                    <label class="text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-2 block">Número da Licitação</label>
                    <v-text-field
                      v-model="data.bidding_number"
                      disabled
                      solo flat dense hide-details
                      class="custom-select opacity-75"
                    />
                  </div>

                  <!-- Número do Contrato -->
                  <div class="md:col-span-3">
                    <label class="text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-2 block">Número do Contrato</label>
                    <v-text-field
                      v-model="data.contract_number"
                      placeholder="000/0000"
                      solo flat dense hide-details
                      class="custom-select"
                    />
                  </div>

                  <!-- Participante -->
                  <div class="md:col-span-6">
                    <label class="text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-2 block">Fornecedor / Participante</label>
                    <v-autocomplete
                      v-model="data.provider_id"
                      :items="providers"
                      item-value="provider_id"
                      item-text="provider_name"
                      :rules="fieldRules"
                      placeholder="SELECIONE O FORNECEDOR..."
                      solo flat dense hide-details
                      class="custom-select"
                    />
                  </div>

                  <!-- Tipo de Licitação -->
                  <div class="md:col-span-6">
                    <label class="text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-2 block">Tipo de Licitação</label>
                    <v-autocomplete
                      v-model="data.type_id"
                      :items="biddings_types"
                      item-value="type_id"
                      item-text="type_desc"
                      :rules="fieldRules"
                      placeholder="SELECIONE O TIPO..."
                      solo flat dense hide-details
                      class="custom-select"
                    />
                  </div>

                  <!-- Modalidade -->
                  <div class="md:col-span-6">
                    <label class="text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-2 block">Modalidade</label>
                    <v-autocomplete
                      v-model="data.modality_id"
                      :items="biddings_modalitites"
                      item-value="modality_id"
                      item-text="modality_desc"
                      :rules="fieldRules"
                      placeholder="SELECIONE A MODALIDADE..."
                      solo flat dense hide-details
                      class="custom-select"
                    />
                  </div>

                  <!-- Início Vigência -->
                  <div class="md:col-span-3">
                    <label class="text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-2 block">Início da Vigência</label>
                    <v-text-field
                      v-model="data.contract_start_term"
                      v-mask-date.br
                      placeholder="DD/MM/AAAA"
                      solo flat dense hide-details
                      class="custom-select"
                    />
                  </div>

                  <!-- Término Vigência -->
                  <div class="md:col-span-3">
                    <label class="text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-2 block">Término da Vigência</label>
                    <v-text-field
                      v-model="data.contract_end_term"
                      v-mask-date.br
                      placeholder="DD/MM/AAAA"
                      solo flat dense hide-details
                      class="custom-select"
                    />
                  </div>

                  <!-- Data Publicação -->
                  <div class="md:col-span-3">
                    <label class="text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-2 block">Data de Publicação</label>
                    <v-text-field
                      v-model="data.contract_publication"
                      v-mask-date.br
                      placeholder="DD/MM/AAAA"
                      solo flat dense hide-details
                      class="custom-select"
                    />
                  </div>

                  <!-- Data Assinatura -->
                  <div class="md:col-span-3">
                    <label class="text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-2 block">Data de Assinatura</label>
                    <v-text-field
                      v-model="data.contract_signature"
                      v-mask-date.br
                      placeholder="DD/MM/AAAA"
                      solo flat dense hide-details
                      class="custom-select"
                    />
                  </div>

                  <!-- Observação -->
                  <div class="md:col-span-12">
                    <label class="text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-2 block">Objeto / Observação</label>
                    <v-textarea
                      v-model="data.contract_obj"
                      placeholder="DESCREVA O OBJETO DO CONTRATO..."
                      solo flat dense hide-details
                      rows="3"
                      class="custom-select"
                    />
                  </div>
                </div>
              </div>
            </section>

            <!-- ITENS DO PARTICIPANTE -->
            <section class="bg-white rounded-xl border border-slate-200 overflow-hidden shadow-sm" v-if="items.length > 0">
              <div class="px-6 py-3 flex items-center gap-3" style="background-color: #333333;">
                <v-icon color="orange" small>mdi-format-list-bulleted</v-icon>
                <h2 class="text-white font-bold uppercase tracking-widest text-[11px]">ITENS DO PARTICIPANTE</h2>
              </div>
              <div class="p-0">
                <v-data-table
                  :headers="headers"
                  :items="items"
                  hide-default-footer
                  class="custom-table"
                />
              </div>
            </section>

            <!-- BOTÕES DE AÇÃO -->
            <section class="bg-white rounded-xl border border-slate-200 overflow-hidden shadow-sm">
              <div class="bg-slate-50 px-8 py-5 flex justify-end items-center gap-4">
                <button 
                  @click="$router.push({ path: `/parts-and-services/biddings-manager/edit/${b_id}`, query: { tab: 3 } })"
                  class="text-slate-500 hover:text-slate-700 font-bold text-[11px] uppercase px-4 py-2 transition-colors flex-none"
                >
                  Cancelar
                </button>
                <div class="flex-none">
                  <button
                    @click="validate"
                    :disabled="!valid || loader"
                    class="bg-orange-500 hover:bg-orange-600 text-white font-bold text-[11px] px-6 py-2.5 rounded shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all w-auto max-w-max whitespace-nowrap flex items-center gap-2"
                  >
                    <v-icon small color="white" class="mr-1" style="font-size: 14px;">mdi-check</v-icon>
                    <span v-if="loader" class="animate-spin h-3 w-3 border-2 border-white border-t-transparent rounded-full"></span>
                    <span v-else>{{ id ? 'SALVAR ALTERAÇÕES' : 'CONFIRMAR CADASTRO' }}</span>
                  </button>
                </div>
              </div>
            </section>

          </div>
        </v-form>
      </div>

    <!-- NOTIFICAÇÕES -->
    <v-snackbar multi-line border="left" :color="snack.color" v-model="snack.show" transition="scroll-y-reverse-transition" class="mb-6">
      <div class="flex items-center gap-3">
        <v-icon color="white">mdi-information-outline</v-icon>
        <span class="font-bold text-xs uppercase tracking-wider">{{ snack.message }}</span>
      </div>
      <template v-slot:action="{ attrs }">
        <v-btn dark text v-bind="attrs" @click="snack.show = false">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

  </div>
</template>

<script>
export default {
  props: ["b_id", "id"],
  data: () => ({
    valid: false,
    loader: false,
    biddings: [],
    providers: [],
    biddings_types: [],
    biddings_modalitites: [],
    items: [],
    headers: [
      { text: "Nº", value: "item_number", align: "start", width: "80px" },
      { text: "Nome", value: "name", align: "start" },
      { text: "Marca", value: "marca", align: "start" },
      { text: "Quantidade", value: "quantidade", align: "start" },
      { text: "Disp.", value: "restante", align: "start" },
    ],
    fieldRules: [(v) => !!v || "Este campo é requerido"],
    snack: {
      show: false,
      message: "",
      color: "success",
    },
    data: {
      bidding_id: null,
      bidding_number: null,
      contract_number: null,
      modality_id: null,
      provider_id: null,
      type_id: null,
      contract_start_term: "",
      contract_end_term: "",
      contract_publication: "",
      contract_signature: "",
      contract_obj: "",
    },
  }),
  created() {
    this.$http.get(`/parts-and-services/biddings/${this.b_id}`).then((r) => {
      this.biddings = r.data;
      this.data.bidding_number = r.data[0].bidding_process_number;
    });
    this.$http
      .get(`/parts-and-services/providers`)
      .then((r) => (this.providers = r.data));

    this.$http
      .get(`/biddings/types`)
      .then((r) => (this.biddings_types = r.data));
    this.$http
      .get(`/biddings/modalities`)
      .then((r) => (this.biddings_modalitites = r.data));
      
    if (this.id) {
      this.$store.dispatch("setLoader", true);
      this.$http
        .get(`/parts-and-services/biddings/contracts/single/${this.id}`)
        .then((r) => {
          this.data = r.data[0];
          this.data.contract_start_term = this.formatDateBr(this.data.contract_start_term);
          this.data.contract_end_term = this.formatDateBr(this.data.contract_end_term);
          this.data.contract_publication = this.formatDateBr(this.data.contract_publication);
          this.data.contract_signature = this.formatDateBr(this.data.contract_signature);

          this.loadItems(this.data.bidding_id, this.data.provider_id);
          this.$store.dispatch("setLoader", false);
        });
    } else {
      this.data.bidding_id = Number(this.b_id);
    }
  },
  methods: {
    formatDateBr(date) {
      if (!date) return "";
      return date.substr(0, 10).split("-").reverse().join("/");
    },
    loadItems(bidding_id, provider_id) {
      this.$http
        .get(`/parts-and-services/biddings/contracts/items/${bidding_id}/${provider_id}`)
        .then((r) => (this.items = r.data));
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.createOrUpdate();
      } else {
        this.snack.show = true;
        this.snack.color = "warning";
        this.snack.message = "Atenção um ou mais campos precisam ser preenchidos!";
      }
    },
    createOrUpdate() {
      this.loader = true;
      this.$store.dispatch("setLoader", true);
      
      const method = this.id ? 'put' : 'post';
      const url = this.id ? `/parts-and-services/biddings/contracts/${this.id}` : "/parts-and-services/biddings/contracts";
      
      this.$http[method](url, this.data)
        .then((r) => {
          this.snack.show = true;
          this.snack.message = r.data.result;
          this.snack.color = "success";
          setTimeout(() => {
            this.$router.push({ path: `/parts-and-services/biddings-manager/edit/${this.b_id}`, query: { tab: 3 } });
          }, 1500);
        })
        .catch((e) => {
          this.snack.show = true;
          this.snack.message = e.message;
          this.snack.color = "error";
          this.loader = false;
          this.$store.dispatch("setLoader", false);
        });
    },
  },
};
</script>

<style scoped>
.custom-select ::v-deep .v-input__slot {
  background: #f8fafc !important;
  border: 1px solid #e2e8f0 !important;
  box-shadow: none !important;
  border-radius: 12px !important;
  height: 48px !important;
  padding: 0 16px !important;
}

.custom-select ::v-deep input {
  font-size: 14px !important;
  font-weight: 600 !important;
  color: #334155 !important;
  text-transform: uppercase !important;
}

.custom-select ::v-deep textarea {
  font-size: 14px !important;
  font-weight: 600 !important;
  color: #334155 !important;
}

.custom-select ::v-deep .v-label {
  font-size: 10px !important;
  font-weight: 900 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.15em !important;
  color: #94a3b8 !important;
}

.custom-table ::v-deep table thead th {
  background-color: #f8fafc !important;
  color: #64748b !important;
  font-size: 10px !important;
  font-weight: 800 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.1em !important;
  height: 40px !important;
  border-bottom: 1px solid #e2e8f0 !important;
}

.custom-table ::v-deep table tbody td {
  height: 48px !important;
  color: #334155 !important;
  border-bottom: 1px solid #f1f5f9 !important;
  font-size: 11px !important;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
.animate-spin {
  animation: spin 1s linear infinite;
}
</style>
